import * as React from "react";
import type { SVGProps } from "react";
const SvgEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#919196"
      d="M23.532 10.65C21.929 8.575 17.597 3.75 12 3.75c-5.669 0-9.962 4.829-11.544 6.9a2.2 2.2 0 0 0 .008 2.694C2.068 15.422 6.402 20.25 12 20.25s9.93-4.825 11.53-6.896a2.2 2.2 0 0 0 .002-2.704M12 16.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
    />
  </svg>
);
export default SvgEye;
